var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLocation)?_c('div',{staticClass:"location__card"},[_c('p',[_vm._v(_vm._s(_vm.getAddressTitle || _vm.title))]),_vm._v(" "),_c('a',{staticClass:"button clear info location__link",attrs:{"href":_vm.getMapLink,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.actionLabel)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }